import CreditAssessmentService from '../../services/CreditAssessmentService';
import CreditAssessmentStatus from '../../model/CreditAssessmentStatus';
import CheckoutActionType from '../../common/CheckoutActionType';
import { PlansSelector } from '../reducers/PlansReducer';
import RestService from '../../services/RestService';

const fetchAddresses = term => dispatch =>
  RestService.getWithHandlers(
    `/api/addressChecker/autoComplete?term=${term}`,
    result => dispatch(
      {
        type: CheckoutActionType.FETCH_ADDRESSES,
        addresses: result.entity
      }
    )
  );

const fetchCurrentAddressDetails = selectedAddress => (dispatch) => {
  CreditAssessmentService.fetchCurrentAddressDetails(selectedAddress.id).then(
    (response) => {
      if (!response.result) {
        // eslint-disable-next-line no-console
        console.error(response);
        dispatch({ type: CheckoutActionType.ADDRESS_SEARCH_ERROR, value: response });
      }
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SET_CURRENT_ADDRESS, currentAddress: response.result });
    }
  );
};

const resetCurrentAddress = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_RESET_CURRENT_ADDRESS });
};

const doSubmit = (values, dispatch, getState, isRetry) => {
  const selectedPlan = PlansSelector.getSelectedPlan(getState());
  const modemPrice = PlansSelector.getModemPrice(getState());
  return CreditAssessmentService.submitCreditAssessment(values, selectedPlan, modemPrice, isRetry)
    .then((response) => {
      if (!response || !response.entity) {
        throw new Error(response);
      }
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_STORE_APPLICATION_ID, value: response.entity });
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_STORE_RESULT, value: undefined });
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SET_RESULT_VIEWED, value: undefined });
    })
    .catch((error) => {
      dispatch({
        type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR,
        error: error && error.status ? error.status : error || true
      });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SUBMITTING, submitting: false });
    });
};

const submit = values => (dispatch, getState) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR, error: undefined });
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SUBMITTING, submitting: true });
  return doSubmit(values, dispatch, getState);
};

const clearCaError = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR, error: undefined });
};

/**
 * Slightly stranger error converter as the error may be an http error or an
 * instance of the JavaScript Error class and we need to handle both.
 * @param error may be an http error or an instance of Error
 * @returns {*}
 */
const getError = (error) => {
  if (error) {
    if (error.message) {
      return { text: error.message };
    } else if (error.status) {
      return { text: error.status };
    }
    return { text: error };
  }
  return { text: 'Unknown Error' };
};

const queryResult = values => (dispatch, getState) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR, error: undefined });
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SUBMITTING, submitting: true });
  const submitCount = getState().form.checkout.values.caSubmitCount || 0;
  return CreditAssessmentService.queryCreditAssessmentResult(values)
    .then(async (response) => {
      if (!response || !response.entity) {
        throw new Error(response);
      }
      const result = response.entity;
      if (result === CreditAssessmentStatus.APPROVED
        || result === CreditAssessmentStatus.DECLINED
        || result === CreditAssessmentStatus.INCORRECT_ID) {
        dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_STORE_RESULT, value: result });
        dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SET_SUBMIT_COUNT, value: submitCount + 1 });
        if (result === CreditAssessmentStatus.INCORRECT_ID) {
          dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR, error: getError(result) });
        }
      } else if (result === CreditAssessmentStatus.IN_PROGRESS) {
        throw new Error(result);
      } else if (result === CreditAssessmentStatus.ERROR) {
        // eslint-disable-next-line no-console
        console.log(result);
        try {
          await doSubmit(values, dispatch, getState, true);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
        throw new Error(result);
      } else {
        throw new Error(result);
      }
    })
    .catch((error) => {
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_ERROR, error: getError(error) });
      return Promise.reject(error);
    })
    .finally(() => {
      dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SUBMITTING, submitting: false });
    });
};

const resetCaSubmitCount = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SET_SUBMIT_COUNT, value: 0 });
};

const setCaResultViewed = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.CREDIT_ASSESSMENT_SET_RESULT_VIEWED, value: true });
};

const CreditAssessmentAction = {
  fetchAddresses,
  fetchCurrentAddressDetails,
  resetCurrentAddress,
  submit,
  queryResult,
  resetCaSubmitCount,
  setCaResultViewed,
  clearCaError
};

export default CreditAssessmentAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/CreditAssessmentAction.js
 **/